var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_21763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_21763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22438 3.25342H13.9904V13.2532L8.46146 18.7501L7.75646 18.0449C7.66993 17.9584 7.59806 17.8438 7.54083 17.7011C7.48375 17.5585 7.45521 17.4242 7.45521 17.2982V17.0865L8.33979 13.2532H2.75646C2.36007 13.2532 2.00993 13.1013 1.70604 12.7974C1.40201 12.4933 1.25 12.1432 1.25 11.747V10.4007C1.25 10.3142 1.26125 10.2207 1.28375 10.1203C1.30611 10.0199 1.33118 9.9264 1.35896 9.83988L3.74688 4.20529C3.86646 3.93821 4.06674 3.71279 4.34771 3.52904C4.62868 3.34529 4.9209 3.25342 5.22438 3.25342ZM12.7404 4.50342H5.22438C5.16563 4.50342 5.10556 4.51939 5.04417 4.55134C4.98264 4.58342 4.93583 4.63689 4.90375 4.71175L2.5 10.3368V11.747C2.5 11.8217 2.52403 11.8831 2.57208 11.9311C2.62014 11.9793 2.6816 12.0034 2.75646 12.0034H9.91979L8.875 16.5707L12.7404 12.7213V4.50342ZM13.9904 13.2532V12.0034H16.6667V4.50342H13.9904V3.25342H17.9167V13.2532H13.9904Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeIcon);
export default __webpack_public_path__ + "static/media/dislike-icon.c58f6fc7368896bcded0b48083a39dc3.svg";
export { ForwardRef as ReactComponent };